var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarFilenowLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 628829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4981",
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V12C24 18.6274 18.6274 24 12 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#1E68F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4982",
    x: 4,
    y: 6,
    width: 16,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4983",
    x: 4,
    y: 11,
    width: 16,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4984",
    x: 4,
    y: 16,
    width: 8,
    height: 2,
    rx: 1,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFilenowLogo);
export default __webpack_public_path__ + "static/media/sidebar_filenow_logo.ed5890d37473e2a9e927cd97c4182901.svg";
export { ForwardRef as ReactComponent };